import cx from 'classnames'

export const clearButtonStyles = {
  /** Put on the element wrapping both the input and the clear button, the button is revealed when it's hovered or has focus within. */
  group: cx('group/clearable'),
  /** Reserves space at the end of the input so text never goes behind the clear button. */
  inputPadding: cx('pe-8'),
}
